import React from "react";
import styled from "styled-components";
import PricingTable from "../Elements/PricingTable";
import { useTranslation } from "react-i18next";

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <Wrapper id="pricing">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold marginTop">{t("NosServices")}</h1>
            <p className="font131">{t("Servicesdetransport")}</p>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull ">
            <TableBox>
              <PricingTable
                icon="roller"
                title={t("TRAJET")}
                text={t("tarif")}
                offers={[
                  { name: t("déplacer"), cheked: true },
                  { name: t("distances"), cheked: true },
                  { name: t("Desserte"), cheked: true },
                ]}
              />
            </TableBox>
            <TableBox>
              <PricingTable
                icon="monitor"
                title={t("mesure")}
                text={t("Disposer")}
                offers={[
                  { name: t("Navette"), cheked: true },
                  { name: t("laéroport"), cheked: true },
                  { name: t("descente"), cheked: true },
                ]}
              />
            </TableBox>
            <TableBox>
              <PricingTable
                icon="browser"
                title={t("BERLINEOUVAN")}
                text={t("passager")}
                offers={[
                  { name: t("standing"), cheked: true },
                  { name: t("Large"), cheked: true },
                  { name: t("aisément"), cheked: true },
                ]}
              />
            </TableBox>
          </TablesWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
  }
`;
